module.exports = __webpack_public_path__ + "static/media/home1.36f1db8b.jpeg";